import React from 'react'

const Radiogroup = ({name, index, options, change, value}) => {
  return (
    <div className="radio-items w-full flex flex-row flex-wrap">
      {options.map((option, o) => (
        <div key={option.label} htmlFor={name} className={`xl:w-1/4 md:w-1/2 w-full mb-2 h-52${options.length-1 === o ? ' flex-1' : ''}`} onClick={ (e) => change(index, option.label)}>
          <div className={`flex mx-1 h-full items-center justify-end text-center p-9 flex-col bg-grey-lightest border-2 ${option.label === value ? 'border-red' : "border-white" } cursor-pointer hover:border-red rounded-md overflow-hidden`}>
            <img src={option.icon} alt={option.label} className="flex-1"/>
            <div className="item-title text-base font-semibold mt-4">{ option.label }</div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default Radiogroup
